// scroll product slider to variant image on change
function handleChange(e) {
  if (e.target.dataset.trigger === 'slicksliderchange') {
    const variantImageSrc =
      e.target.selectedOptions[0].dataset.slickSliderChange;
    const sliders = document.querySelectorAll('#product-media-slider');

    // since there's two different slider libraries running on the site (?!) we need to handle them separately
    sliders.forEach((slider) => {
      if (!slider) return null;

      if (slider.slick) {
        // get the index of the slide with a matching image
        const slide = Array.from(
          slider.querySelectorAll('[data-slick-slider-change]')
        ).find((slide) =>
          variantImageSrc.match(slide.dataset.slickSliderChange)
        );

        if (slide) {
          const { slickIndex } = slide.dataset;
          return slider.slick.slickGoTo(slickIndex);
        }
      }

      if (slider.swiper) {
        // can't easily implement, leaving this case for potential future fixes
      }
    });
  }
}

document.addEventListener('change', handleChange);
